import { SVGProps } from 'react'

import { Nullable } from '@f-fertighaus/applications/Next/types/utility'

interface RatingStarProps {
  onClick?: () => void
  onMouseEnter: () => void
  onMouseLeave: () => void
  color?: Nullable<{ stroke: string; fill: string }>
  dataTestId?: string
}

export const RatingStar = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  dataTestId,
  color = { stroke: '#D2D4D9', fill: '#F0F1F2' }
}: RatingStarProps) => {
  return (
    <StarIcon
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      fill={color?.fill}
      stroke={color?.stroke}
      dataTestId={dataTestId}
    />
  )
}

const StarIcon = ({
  fill,
  stroke,
  onClick,
  onMouseEnter,
  onMouseLeave,
  dataTestId,
  ...props
}: RatingStarProps & SVGProps<SVGSVGElement>) => (
  <div
    className='reputation-rating-icon'
    data-testid={dataTestId}
    onClick={onClick}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}>
    <svg
      width='64'
      height='64'
      viewBox='40 38 64 64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <g filter='url(#filter0_ddd_653_818)'>
        <rect x='40' y='38' width='64' height='64' rx='4' fill='white' />
        <path
          d='M64.1457 61.8167L64.406 61.7788L64.5222 61.5429L71.1076 48.1707C71.4729 47.4288 72.5272 47.4288 72.8926 48.1707L79.4779 61.5429L79.5941 61.7788L79.8544 61.8167L94.5761 63.9609C95.3914 64.0797 95.7202 65.0864 95.1276 65.6654L84.4741 76.0732L84.2864 76.2566L84.3306 76.5152L86.8449 91.2143C86.9849 92.0329 86.1288 92.6515 85.4008 92.2678L72.2332 85.3284L72.0001 85.2055L71.7669 85.3284L58.5993 92.2678C57.8713 92.6515 57.0152 92.0329 57.1552 91.2143L59.6695 76.5152L59.7137 76.2566L59.526 76.0732L48.8725 65.6654C48.2799 65.0864 48.6087 64.0797 49.424 63.9609L64.1457 61.8167Z'
          fill={fill}
          stroke={stroke}
        />
      </g>
      <defs>
        <filter
          id='filter0_ddd_653_818'
          x='0'
          y='0'
          width='144'
          height='144'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='20' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.231373 0 0 0 0 0.278431 0 0 0 0 0.407843 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_653_818'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='3'
            operator='erode'
            in='SourceAlpha'
            result='effect2_dropShadow_653_818'
          />
          <feOffset dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.231373 0 0 0 0 0.278431 0 0 0 0 0.407843 0 0 0 1 0'
          />
          <feBlend
            mode='normal'
            in2='effect1_dropShadow_653_818'
            result='effect2_dropShadow_653_818'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology
            radius='1'
            operator='erode'
            in='SourceAlpha'
            result='effect3_dropShadow_653_818'
          />
          <feOffset dy='5' />
          <feGaussianBlur stdDeviation='5' />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0.231373 0 0 0 0 0.278431 0 0 0 0 0.407843 0 0 0 0.05 0'
          />
          <feBlend
            mode='normal'
            in2='effect2_dropShadow_653_818'
            result='effect3_dropShadow_653_818'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect3_dropShadow_653_818'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  </div>
)
